import { render } from "./UpdatePasswordPage.vue?vue&type=template&id=500f91d7"
import script from "./UpdatePasswordPage.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordPage.vue?vue&type=script&lang=js"

import "./UpdatePasswordPage.vue?vue&type=style&index=0&id=500f91d7&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__